import { yupResolver } from "@hookform/resolvers/yup";
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import FormHubScanTransferOrder from "components/Common/Form/FormHubScanTransferOrder";
import { TRANSFER_ORDER_TYPE } from "constants/order";
import { useQueryRouter } from "helpers/utils";
import { resolveReceiveBusChildScanAction } from "pages/Orders/utils";
import { useCheckRole, useMyHubsList } from "hooks";
import { useUploadResource } from "hooks/import-management/useImport";
import {
  useOrderScanRemoveFile,
  useOrderScanUploadFile,
  useScanStartStatus,
} from "hooks/order-scan/useOrderScan";
import { useOrderStatus } from "hooks/order/useOrder";
import { useTransports } from "hooks/transport/useTransport";
import TransferOrderChild from "pages/ManageTransferOrders/TransferOrderChild";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import * as yup from "yup";
import BarcodePDFGenerator from "../BarcodeGenerator/BarcodeGenerator";
import BarcodeScannerAddModal from "../BarcodeScannerAddModal";
import BarcodeScannerModal, { LABEL_SCAN_CODE } from "../BarcodeScannerModal";
import DetailOrderScan from "../DetailOrderScan/DetailOrderScan";
import ReactCamera from "../ReactCamera/ReactCamera";
import SocketPrintBarCode from "../SocketPrint/SocketPrintBarCode";
import StartEndScanOrder from "../StartEndScanOrder/StartEndScanOrder";
import "./ScanRow.scss";
import { Switch } from "antd";

const ScanRow = props => {
  const { isSendOrder } = props;
  const { isLogAdmin } = useCheckRole();

  const { addToast } = useToasts();
  let queryRouter = useQueryRouter();
  const navigate = useNavigate();
  // const [is_level_2, setIsLevel2] = useState(true);
  const startScanIdQuery = queryRouter.get("startScanId");
  const allowedGroupToTransferQuery = queryRouter.get("transfer");
  const hubFromQuery = queryRouter.get("from");
  const hubToQuery = queryRouter.get("to");

  // START Yup transfer order
  const { refetch: fetchOrderStatusList, data: orderStatusList } =
    useOrderStatus();
  const orderChildRef = useRef(null);
  const hubRef = useRef(null);

  const initDefaultValues = {
    hubSend: null,
    hubReceive: null,
    allowedGroupToTransfer: allowedGroupToTransferQuery === "1",
    transferOrderType: !isSendOrder
      ? TRANSFER_ORDER_TYPE.RECEIVE
      : TRANSFER_ORDER_TYPE.RETURN,
    childOrders: [],
    childOrdersSelected: [],
  };
  const { t } = useTranslation(["order"]);
  const ruleTransferOrder = {
    allowedGroupToTransfer: yup.bool(),
    transferOrderType: yup.string(),
    deliveryHubReceive: yup.object().nullable(),
    childOrders: yup
      .array()
      .min(
        1,
        t("form.validate.select", {
          title: "Đơn con",
        })
      )
      .nullable(),
  };
  const schema = yup.object().shape(ruleTransferOrder);
  const transferOrderForm = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields },
    control,
    watch,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = transferOrderForm;
  const {
    childOrders,
    childOrdersSelected,
    transferOrderType,
    allowedGroupToTransfer,
    hubSend,
    hubReceive,
  } = watch();

  // END Yup transfer order

  const [listImageCapture, setListImageCapture] = useState([]);

  const [transportsFilter, setTransportsFilter] = useState([]);
  const [selectedTransportsFilter, setSelectedTransportsFilter] =
    useState(null);

  const [isOpenSelectedTransportsFilter, setIsOpenSelectedTransportsFilter] =
    useState(false);

  const [isCameraActive, setCameraActive] = useState(false);
  const [messStatusCamera, setMessStatusCamera] = useState("");

  const [isPrinterActive, setPrinterActive] = useState(false);
  const [messStatusPrinter, setMessStatusPrinter] = useState("");

  const webcamRef = useRef(null);
  const barcodePDFGeneratorRef = useRef(null);
  const socketPrintBarCodeRef = useRef(null);

  const [canStart, setCanStart] = useState(null);
  const [scanIdOrder, setScanIdOrder] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const [orderDataInfo, setOrderDataInfo] = useState(null);
  const [allowFocusInputBarcode, setAllowFocusInputBarcode] = useState(true);
  const barcodeInputFocusRef = useRef(null);
  const [autoOpenReceiveBusChildBarcode, setAutoOpenReceiveBusChildBarcode] =
    useState(null);

  const { data: myHubs } = useMyHubsList({ enabled: true });

  const startStatusParams = useMemo(
    () => ({
      isSendOrder,
      allowed_group_to_transfer: allowedGroupToTransfer ? 1 : 0,
      hub_id: myHubs?.hub?.id,
      from_hub: allowedGroupToTransfer ? hubSend?.id : undefined,
      to_hub: allowedGroupToTransfer ? hubReceive?.id : undefined,
    }),
    [
      isSendOrder,
      allowedGroupToTransfer,
      myHubs?.hub?.id,
      hubSend?.id,
      hubReceive?.id,
    ]
  );

  const isStartStatusQueryEnabled =
    !!startStatusParams.hub_id &&
    (!allowedGroupToTransfer || (hubSend?.id && hubReceive?.id));

  const {
    data: startStatus,
    isFetching: isFetchingStartStatus,
    isSuccess: isStartStatusSuccess,
    isError: isStartStatusError,
  } = useScanStartStatus(startStatusParams, {
    enabled: isStartStatusQueryEnabled,
  });

  const isWaitingStartStatus =
    isStartStatusQueryEnabled &&
    (isFetchingStartStatus || (!isStartStatusSuccess && !isStartStatusError));

  const isStartStatusResolved = !isStartStatusQueryEnabled || !isWaitingStartStatus;

  const shouldShowStartButton =
    isStartStatusResolved && isStartStatusQueryEnabled && canStart === true;

  const isScanInputLocked =
    !isStartStatusQueryEnabled ||
    isWaitingStartStatus ||
    canStart === true;

  const applyScanSessionFromApi = useCallback(({ canStart: canStartValue, scanId }) => {
    setCanStart(canStartValue === true);
    setScanIdOrder(scanId || null);
  }, []);

  useEffect(() => {
    if (!isStartStatusQueryEnabled || !isFetchingStartStatus) {
      return;
    }

    setCanStart(null);
  }, [isStartStatusQueryEnabled, isFetchingStartStatus]);

  useEffect(() => {
    if (!startStatus) {
      return;
    }

    applyScanSessionFromApi(startStatus);
  }, [startStatus, applyScanSessionFromApi]);

  useEffect(() => {
    if (!isStartStatusError) {
      return;
    }

    setCanStart(false);
  }, [isStartStatusError]);

  const handleScanStartSuccess = useCallback(
    session => {
      applyScanSessionFromApi(session);

      if (session?.canStart !== true) {
        barcodeInputFocusRef.current?.();
      }
    },
    [applyScanSessionFromApi]
  );

  // TRANSPORT
  const allFilterTransportOption = {
    id: undefined,
    name: "Tất cả",
  };
  const onFetchTransportsSuccess = response => {
    const transportResponse = response?.items || [];
    setTransportsFilter([allFilterTransportOption, ...transportResponse]);
    setSelectedTransportsFilter(allFilterTransportOption);
  };

  const { refetch: onFetchTransports } = useTransports(
    { params: {} },
    onFetchTransportsSuccess
  );
  //
  const { mutate: mutateOrderScanUploadFile } = useOrderScanUploadFile({
    onSuccess: data => {},
    onError: () => {},
  });
  //

  const { mutate: mutateOrderScanRemoveFile } = useOrderScanRemoveFile({
    onSuccess: data => {},
    onError: () => {},
  });
  //
  const onUploadImageSuccess = response => {
    if (response?.data?.id) {
      setListImageCapture(prev => {
        const lastIndex = prev.length - 1;
        const lastItem = prev[lastIndex];
        const updatedItem = {
          ...lastItem,
          idResouce: response?.data?.id, // Replace 'newidResouce' with the desired value for idResouce
        };
        const updatedList = [...prev.slice(0, lastIndex), updatedItem];
        //
        mutateOrderScanUploadFile({
          idHistoryScan: orderData?.id,
          listIdResource: updatedList.map(item => item.idResouce),
        });
        //
        return updatedList;
      });
    }
  };

  const { mutate: mutateUploadImage } = useUploadResource(onUploadImageSuccess);

  function convertBase64ToFile(base64String, fileName) {
    const decodedData = window.atob(base64String);
    const byteCharacters = decodedData;
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/octet-stream" });
    const file = new File([blob], fileName);
    return file;
  }

  const handleCaptureImage = srcImage => {
    const data = new FormData();
    const cleanedBase64String = srcImage.replace(
      /^data:image\/[a-z]+;base64,/,
      ""
    );
    const fileName = `scan_${new Date().getTime()}.png`;
    data.append("file", convertBase64ToFile(cleanedBase64String, fileName));
    mutateUploadImage(data);
    setListImageCapture(prev => {
      return [
        ...prev,
        {
          srcImage: srcImage,
          fileName,
          idResouce: null,
        },
      ];
    });
  };

  const handleActiveCamera = ({ isConnect, message }) => {
    setCameraActive(isConnect);
    setMessStatusCamera(message);
  };

  const removeImage = idResouce => {
    setListImageCapture(prev => {
      const updatedList = prev.filter(item => item.idResouce !== idResouce);
      //
      mutateOrderScanRemoveFile({
        listIdResource: [idResouce],
      });
      //
      return updatedList;
    });
  };

  const printBarcode = async ({
    barcodeValue,
    subLabel,
    hubReceive = undefined,
  }) => {
    const base64 = await barcodePDFGeneratorRef?.current?.generatePDFBase64({
      barcodeValue: barcodeValue,
      subLabel: subLabel,
      hubReceive,
    });
    socketPrintBarCodeRef?.current?.printBase64({ base64: base64 });
  };

  const printBarcodeAuto = async listBarCode => {
    for (const item of listBarCode) {
      await printBarcode({ barcodeValue: item?.code, subLabel: item?.content });
    }
  };

  useEffect(() => {
    setListImageCapture([]);
    if (orderData?.scan_code) {
      // Có thông tin order thì trigger chụp hình
      webcamRef?.current?.captureImage();

      // Loại chức năng in đơn con khi quét đơn trả kết quả
      // không in barcode đơn con trong những trường hợp sau đây:
      //   - Là logadmin
      //   - Là đơn trung chuyển
      //   - Là đơn loại nhận mẫu
      const extendCondition =
        isLogAdmin &&
        orderData?.object?.is_transfer_order === 1 &&
        orderData?.object?.type === 2;
      if (
        !isSendOrder &&
        orderData?.object?.childs?.length > 0 &&
        !extendCondition
      ) {
        console.log("Print barcode auto genderate! ");
        printBarcodeAuto(orderData?.object?.childs);
      }
    }
  }, [orderData, orderDataInfo, isLogAdmin]);

  useEffect(() => {
    if (!scanIdOrder) {
      setOrderData(null);
      setOrderDataInfo(null);
      setAutoOpenReceiveBusChildBarcode(null);
    }
  }, [scanIdOrder]);

  useEffect(() => {
    //Id từ đợt quét kiện
    if (startScanIdQuery) {
      setScanIdOrder(startScanIdQuery);
      setCanStart(false);
    }
    if (allowedGroupToTransferQuery === "1") {
      setValue(
        "allowedGroupToTransfer",
        allowedGroupToTransferQuery === "1" ? true : false
      );
    }
    onFetchTransports();
  }, [startScanIdQuery, allowedGroupToTransferQuery]);

  return (
    <React.Fragment>
      <div className="page-content order-scan">
        <MetaTags>
          <title>
            {isSendOrder ? LABEL_SCAN_CODE.SEND : LABEL_SCAN_CODE.RECEIVE}
          </title>
        </MetaTags>
        <Container fluid>
          <BreadcrumbWithLink title={""} style={{ marginBottom: "0px" }} />
          <div
            className="d-flex gap-2"
            style={{ justifyContent: "space-between", flexWrap: "wrap" }}
          >
            <SocketPrintBarCode
              ref={socketPrintBarCodeRef}
              handleConnect={({ isConnect, message }) => {
                setPrinterActive(isConnect);
                setMessStatusPrinter(message);
              }}
            />
            <BarcodePDFGenerator ref={barcodePDFGeneratorRef} />
            <div className="d-flex gap-2" style={{ flexWrap: "wrap" }}>
              <BarcodeScannerModal
                transport_id={
                  !allowedGroupToTransfer ? selectedTransportsFilter?.id : null
                }
                allowed_group_to_transfer={allowedGroupToTransfer}
                from_hub={allowedGroupToTransfer ? hubSend : null}
                to_hub={allowedGroupToTransfer ? hubReceive : null}
                myHub={
                  allowedGroupToTransfer ? hubRef?.current?.getMyHub() : null
                }
                scan_id={scanIdOrder}
                requireScanSession={isScanInputLocked}
                registerFocusInput={focusInput => {
                  barcodeInputFocusRef.current = focusInput;
                }}
                isSendOrder={isSendOrder}
                allowFocusInput={allowFocusInputBarcode}
                orderData={orderData}
                orderDataInfo={orderDataInfo}
                setOrderData={(data, meta) => {
                  const scanAction = resolveReceiveBusChildScanAction({
                    data,
                    previousOrder: meta?.previousOrder,
                    barcode: meta?.barcode,
                    isSendOrder,
                  });

                  setOrderData(scanAction.orderData);

                  if (scanAction.action === "open_modal") {
                    setAutoOpenReceiveBusChildBarcode(
                      scanAction.initialBarcode ?? ""
                    );
                  }

                  // Add vào danh sách đơn con để tạo đơn trung chuyển
                  if (scanAction.orderData?.object && allowedGroupToTransfer) {
                    const { object } = scanAction.orderData;
                    if (object?.is_transfer_order) {
                      const listChild =
                        object?.child_info?.map(child => {
                          return {
                            id: child?.id,
                            checker_date: child?.checker_date,
                            order_code: child?.order_code,
                            status: child?.status,
                            type: child?.type,

                            sender_name: child?.sender_name,
                            sender_contact_phone: child?.sender_contact_phone,
                            sender_full_address: child?.sender_full_address,

                            reciever_name: child?.reciever_name,
                            reciever_contact_phone:
                              child?.reciever_contact_phone,
                            reciever_full_address: child?.reciever_full_address,
                            maker_date: child?.maker_date,
                            ref_code: child?.ref_code,
                            imagePath: child?.imagePath,
                            transport_name: child?.transport_name,
                          };
                        }) || [];
                      orderChildRef?.current?.addListChildOfParent(listChild);
                    } else {
                      orderChildRef?.current?.addChild({
                        id: object?.id,
                        checker_date: object?.checker_date,
                        order_code: object?.order_code,
                        status: object?.status,
                        type: object?.type,

                        sender_name: object?.sender_name,
                        sender_contact_phone: object?.sender_contact_phone,
                        sender_full_address: object?.sender_full_address,

                        reciever_name: object?.reciever_name,
                        reciever_contact_phone: object?.reciever_contact_phone,
                        reciever_full_address: object?.reciever_full_address,
                        maker_date: object?.maker_date,
                        ref_code: object?.ref_code,
                        imagePath: object?.imagePath,
                        transport_name: object?.transport_name,
                      });
                    }
                  }
                }}
                setOrderDataInfo={(data, meta) => {
                  const scanAction = resolveReceiveBusChildScanAction({
                    data,
                    previousOrder: meta?.previousOrder,
                    barcode: meta?.barcode,
                    isSendOrder,
                  });

                  setOrderDataInfo(scanAction.orderData);

                  if (scanAction.action === "open_modal") {
                    setAutoOpenReceiveBusChildBarcode(
                      scanAction.initialBarcode ?? ""
                    );
                  }
                }}
              ></BarcodeScannerModal>
              <div
                style={{ marginTop: "2px" }}
                className="camera-printer-status"
              >
                <div
                  title={`${isCameraActive ? "Hoạt động" : "Không hoạt động"}`}
                  className="d-flex align-items-center gap-1 camera"
                >
                  <i
                    className={`bx bxs-circle ${
                      isCameraActive ? "text-success" : "text-danger"
                    }`}
                  ></i>
                  <div className="fw-bold" style={{ fontStyle: "italic" }}>
                    Camera
                  </div>
                  {messStatusCamera && (
                    <div
                      className="text-warning fw-bold font-size-14"
                      style={{ fontStyle: "italic" }}
                    >
                      ({messStatusCamera})
                    </div>
                  )}
                </div>
                <div
                  title={`${isCameraActive ? "Hoạt động" : "Không hoạt động"}`}
                  className="d-flex align-items-center gap-1 printer"
                >
                  <i
                    className={`bx bxs-circle ${
                      isPrinterActive ? "text-success" : "text-danger"
                    }`}
                  ></i>
                  <div className="fw-bold" style={{ fontStyle: "italic" }}>
                    Printer
                  </div>
                  {messStatusPrinter && (
                    <div
                      className="text-warning fw-bold font-size-14 messStatusPrinter"
                      style={{ fontStyle: "italic" }}
                    >
                      ({messStatusPrinter})
                    </div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <FormHubScanTransferOrder
                  formHook={transferOrderForm}
                  fieldNameHubSend={"hubSend"}
                  fieldNameHubReceive={"hubReceive"}
                  ref={hubRef}
                  disabled={isScanInputLocked && !!scanIdOrder}
                  transferOrderType={transferOrderType}
                  handleAllowedGroupToTransfer={({
                    isAllowedGroupToTransfer,
                    userType,
                  }) => {
                    setValue(
                      "allowedGroupToTransfer",
                      isAllowedGroupToTransfer
                    );
                  }}
                  allowGroupToTranferDefault={allowedGroupToTransfer}
                  hubSendDefault={hubFromQuery}
                  hubReceiveDefault={hubToQuery}
                  addressLevel={3}
                />
              </div>

              {!allowedGroupToTransfer && (
                <div style={{ marginTop: "10px" }} className="transport-select">
                  <Dropdown
                    isOpen={isOpenSelectedTransportsFilter}
                    toggle={() =>
                      setIsOpenSelectedTransportsFilter(
                        !isOpenSelectedTransportsFilter
                      )
                    }
                  >
                    <DropdownToggle className="btn primary-btn w-100" caret>
                      {"ĐVVC"}
                      {selectedTransportsFilter && (
                        <span>:&nbsp;{selectedTransportsFilter?.name}</span>
                      )}
                      <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu className="w-100">
                      {transportsFilter?.map((type, index) => (
                        <DropdownItem
                          key={`shipping-type-${index}`}
                          onClick={() => {
                            setIsOpenSelectedTransportsFilter(
                              !isOpenSelectedTransportsFilter
                            );
                            setSelectedTransportsFilter(type);
                          }}
                        >
                          {type?.name}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              )}
              {/* <Label
                className="d-flex align-items-center gap-1 mb-0"
                style={{ cursor: "pointer" }}
                htmlFor="is_level_2"
                onClick={() => setIsLevel2(!is_level_2)}
              >
                <Switch checked={is_level_2} onChange={setIsLevel2} />
                Địa chỉ 2 cấp
              </Label> */}
            </div>

            <div
              className="d-flex"
              style={{
                width: "500px",
                marginTop: "10px",
                justifyContent: "space-between",
              }}
            >
              <StartEndScanOrder
                isSendOrder={isSendOrder}
                showStartButton={shouldShowStartButton}
                onScanStartSuccess={handleScanStartSuccess}
                hubId={myHubs?.hub?.id}
                allowedGroupToTransfer={allowedGroupToTransfer}
                hubDeliver={{
                  from: hubSend?.id,
                  to: hubReceive?.id,
                }}
              />
              <BarcodeScannerAddModal
                isSendOrder={isSendOrder}
                handleOpenAddBarcodeModal={isOpen => {
                  if (isOpen) {
                    setAllowFocusInputBarcode(false);
                  } else {
                    setAllowFocusInputBarcode(true);
                  }
                }}
              />
            </div>
          </div>
          <div className="d-flex gap-2 w-100 mt-2 main-content-scan">
            <div className="form">
              {allowedGroupToTransfer && (
                <TransferOrderChild
                  ref={orderChildRef}
                  isShowRowsSelected
                  isDeleteTemp
                  isShowBtnDeleteChild={true}
                  title={
                    orderData?.object?.is_transfer_order
                      ? "Danh sách đơn con của đơn đã quét"
                      : "Danh sách đơn đã quét"
                  }
                  mainForm={transferOrderForm}
                  pathDetail={"manage-orders"}
                  fieldChildName={"childOrders"}
                  fieldChildSelectedName={"childOrdersSelected"}
                  orderStatusList={orderStatusList}
                  extraButton={
                    !orderData?.object?.is_transfer_order && (
                      <Button
                        className="mb-2 w-100"
                        color={"primary"}
                        type="button"
                        onClick={() => {
                          if (childOrders?.length === 0) {
                            addToast(
                              "Vui lòng quét đơn muốn tạo đơn trung chuyển",
                              {
                                appearance: "warning",
                                autoDismiss: true,
                              }
                            );
                            return;
                          }
                          if (childOrdersSelected?.length === 0) {
                            addToast(
                              "Vui lòng chọn đơn con muốn tạo đơn trung chuyển",
                              {
                                appearance: "warning",
                                autoDismiss: true,
                              }
                            );
                            return;
                          }
                          navigate(
                            { pathname: "/manage-transfer-orders/create" },
                            {
                              state: {
                                type: transferOrderType,
                                from_hub: hubSend,
                                to_hub: hubReceive,
                                listOrders: childOrdersSelected,
                                is_send_order: isSendOrder,
                              },
                            }
                          );
                        }}
                      >
                        {"Tạo đơn trung chuyển "}({childOrdersSelected?.length}{" "}
                        đơn con)
                      </Button>
                    )
                  }
                />
              )}

              <Card
                style={{
                  height: "100%",
                  flex: 1,
                }}
              >
                <CardBody
                  style={{
                    height: "100%",
                    minHeight: "76px",
                  }}
                >
                  <div></div>
                  <div className="d-flex align-items-center">
                    <h5>
                      {!orderData?.scan_code && (
                        <div
                          className="text-danger fw-bold"
                          style={{ fontStyle: "italic" }}
                        >
                          {orderData}
                        </div>
                      )}
                      Thông tin đơn hàng
                    </h5>
                    {orderData?.object?.is_transfer_order === 1 && (
                      <Alert className="mx-4" color="warning">
                        Bạn đang quét kiện đơn trung chuyển !
                      </Alert>
                    )}
                  </div>

                  {orderData?.scan_code && (
                    <DetailOrderScan
                      printBarcode={printBarcode}
                      scanCode={orderData?.scan_code}
                      scanSessionId={orderData?.id}
                      order={orderData?.object}
                      autoOpenReceiveBusChildBarcode={
                        autoOpenReceiveBusChildBarcode
                      }
                      onAutoOpenReceiveBusChildConsumed={() =>
                        setAutoOpenReceiveBusChildBarcode(null)
                      }
                      onScanFocusLockChange={isLocked => {
                        setAllowFocusInputBarcode(!isLocked);
                      }}
                    ></DetailOrderScan>
                  )}

                  {orderDataInfo?.scan_code && (
                    <DetailOrderScan
                      printBarcode={printBarcode}
                      scanCode={orderDataInfo?.scan_code}
                      order={orderDataInfo}
                      autoOpenReceiveBusChildBarcode={
                        autoOpenReceiveBusChildBarcode
                      }
                      onAutoOpenReceiveBusChildConsumed={() =>
                        setAutoOpenReceiveBusChildBarcode(null)
                      }
                      onScanFocusLockChange={isLocked => {
                        setAllowFocusInputBarcode(!isLocked);
                      }}
                    ></DetailOrderScan>
                  )}
                </CardBody>
              </Card>
            </div>

            <Card className="camera-control">
              <CardBody
                style={{
                  height: "100%",
                }}
              >
                <div
                  className="d-flex mb-2"
                  style={{ justifyContent: "space-between", flexWrap: "wrap" }}
                >
                  <h5 style={{ width: "80px" }}>Hình ảnh</h5>
                  <div style={{ marginTop: "-7px" }}>
                    <ReactCamera
                      ref={webcamRef}
                      isAllowCapture={orderData ? true : false}
                      handleOnFocusListSelectCamera={() => {
                        setAllowFocusInputBarcode(false);
                      }}
                      handleOnBlurListSelectCamera={() => {
                        setAllowFocusInputBarcode(true);
                      }}
                      handleActiveCamera={handleActiveCamera}
                      handleCaptureImage={handleCaptureImage}
                    ></ReactCamera>
                  </div>
                </div>

                <div
                  className="d-flex gap-3"
                  style={{
                    flexDirection: "column",
                    height: "100%",
                    overflow: "auto",
                  }}
                >
                  {listImageCapture.map((item, index) => {
                    return (
                      <div key={index} className="image-container">
                        <img
                          src={item.srcImage}
                          alt="Captured"
                          style={{ width: "100%" }}
                        />
                        <i
                          className="fas fa-trash fa-lg text-danger trash-icon"
                          title="Xóa hình ảnh"
                          onClick={() => {
                            removeImage(item?.idResouce);
                          }}
                        ></i>
                      </div>
                    );
                  })}
                </div>
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

ScanRow.propTypes = {
  isSendOrder: PropTypes.bool,
};

ScanRow.defaultProps = {
  isSendOrder: false,
};

export default ScanRow;
